import {
  Column,
  CreateDateColumn,
  DeleteDateColumn,
  Entity,
  ManyToOne,
  PrimaryGeneratedColumn
} from 'typeorm';
import { serialize } from '../helper';
import PerguntaNoPedido from './PerguntaNoPedido';
import Resposta from './Resposta';

@Entity()
export class RespostaNoPedido {
  @PrimaryGeneratedColumn()
  id!: number;

  @Column()
  respostaId!: number;

  @Column()
  descricao!: string;

  @Column()
  preco!: number;

  @Column()
  quantidade: number = 1;

  @ManyToOne(() => PerguntaNoPedido)
  perguntaNoPedido!: PerguntaNoPedido;

  @CreateDateColumn({ select: false })
  createdAt!: Date;

  @DeleteDateColumn({ select: false })
  deletedAt!: Date;
}

export default RespostaNoPedido;

export const criarRespostaNoPedido = (resposta: Resposta) => {
  const respostaNoPedido = new RespostaNoPedido();
  Object.assign(respostaNoPedido, resposta);
  delete respostaNoPedido.id;
  respostaNoPedido.respostaId = resposta.id;
  return serialize<RespostaNoPedido>(respostaNoPedido);
};
